// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__Qkmy8","label":"Checkbox_label__2jhHe","checkbox":"Checkbox_checkbox__4anjR","errorText":"Checkbox_errorText__bf+YN"};